(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands-carousel"] && !Shopify.designMode) return;
  try {
    
  class BrandsCarouselComponent extends HTMLElement {
    constructor() {
      super();
      this.list = this.querySelector('.brands-carousel__list');
      this.scrollbarThumb = this.querySelector('.brands-carousel__scrollbar-thumb');
      this.scrollbarTrack = this.querySelector('.brands-carousel__scrollbar-track');

      if (this.list) {
        this.init();
      }
    }

    init() {
      this.list.addEventListener('scroll', () => this.updateScrollbar());
      this.updateScrollbar();

      const resizeObserver = new ResizeObserver(() => this.updateScrollbar());
      resizeObserver.observe(this.list);

      // Make scrollbar draggable
      if (this.scrollbarThumb && this.scrollbarTrack) {
        this.initDraggableScrollbar();
      }
    }

    initDraggableScrollbar() {
      let isDragging = false;
      let startX = 0;
      let startScrollLeft = 0;

      this.scrollbarThumb.addEventListener('mousedown', (e) => {
        isDragging = true;
        startX = e.clientX;
        startScrollLeft = this.list.scrollLeft;
        this.scrollbarThumb.style.cursor = 'grabbing';
        e.preventDefault();
      });

      document.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        const trackWidth = this.scrollbarTrack.offsetWidth;
        const thumbWidth = this.scrollbarThumb.offsetWidth;
        const maxThumbMove = trackWidth - thumbWidth;
        const deltaX = e.clientX - startX;
        const scrollRatio = deltaX / maxThumbMove;
        const maxScroll = this.list.scrollWidth - this.list.clientWidth;
        this.list.scrollLeft = startScrollLeft + scrollRatio * maxScroll;
      });

      document.addEventListener('mouseup', () => {
        if (isDragging) {
          isDragging = false;
          this.scrollbarThumb.style.cursor = 'grab';
        }
      });

      // Click on track to jump
      this.scrollbarTrack.addEventListener('click', (e) => {
        if (e.target === this.scrollbarThumb) return;
        const rect = this.scrollbarTrack.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const trackWidth = this.scrollbarTrack.offsetWidth;
        const ratio = clickX / trackWidth;
        const maxScroll = this.list.scrollWidth - this.list.clientWidth;
        this.list.scrollTo({ left: ratio * maxScroll, behavior: 'smooth' });
      });
    }

    updateScrollbar() {
      if (!this.scrollbarThumb) return;

      const { scrollLeft, scrollWidth, clientWidth } = this.list;
      const maxScroll = scrollWidth - clientWidth;

      if (maxScroll <= 0) {
        this.scrollbarThumb.parentElement.style.display = 'none';
        return;
      }

      this.scrollbarThumb.parentElement.style.display = 'block';
      const thumbWidth = Math.max(20, (clientWidth / scrollWidth) * 100);
      const thumbPosition = (scrollLeft / maxScroll) * (100 - thumbWidth);

      this.scrollbarThumb.style.width = `${thumbWidth}%`;
      this.scrollbarThumb.style.left = `${thumbPosition}%`;
    }
  }

  if (!customElements.get('brands-carousel-component')) {
    customElements.define('brands-carousel-component', BrandsCarouselComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-vecno"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.header-vecno-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  // Mobile Menu Drawer
  (function() {
    var drawer = document.getElementById('header-vecno-drawer');
    var overlay = document.getElementById('header-vecno-overlay');
    var toggleBtn = document.querySelector('.header-vecno__menu-toggle');
    var closeBtn = drawer ? drawer.querySelector('.vecno-drawer__close') : null;

    if (!drawer || !toggleBtn) return;

    // Move drawer and overlay to body to avoid stacking context issues
    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    function openDrawer() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      toggleBtn.setAttribute('aria-expanded', 'true');
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      toggleBtn.setAttribute('aria-expanded', 'false');
    }

    toggleBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeDrawer();
    });

    // Mobile Search Overlay
    var searchToggle = document.querySelector('.header-vecno__search-toggle');
    var searchOverlay = document.getElementById('mobileSearchOverlay');
    if (searchToggle && searchOverlay) {
      // Move to body to avoid stacking context issues with product cards
      document.body.appendChild(searchOverlay);
      var searchInput = searchOverlay.querySelector('.mobile-search-bar__input');
      var searchClose = searchOverlay.querySelector('.mobile-search-bar__close');

      searchToggle.addEventListener('click', function() {
        searchOverlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        if (searchInput) setTimeout(function() { searchInput.focus(); }, 100);
      });

      function closeMobileSearch() {
        searchOverlay.classList.remove('is-open');
        document.body.style.overflow = '';
      }

      if (searchClose) searchClose.addEventListener('click', closeMobileSearch);
      searchOverlay.addEventListener('click', function(e) {
        if (e.target === searchOverlay) closeMobileSearch();
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && searchOverlay.classList.contains('is-open')) closeMobileSearch();
      });
    }

    // Drawer sub-menu toggles
    var parentBtns = drawer.querySelectorAll('.vecno-drawer__menu-link--parent');
    parentBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var items = btn.nextElementSibling;
        var isOpen = items.classList.contains('is-open');
        // Close all others
        parentBtns.forEach(function(b) {
          b.setAttribute('aria-expanded', 'false');
          b.nextElementSibling.classList.remove('is-open');
        });
        if (!isOpen) {
          items.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  class HeroCarousel extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('.hero-carousel__track');
      this.slides = Array.from(this.querySelectorAll('.hero-carousel__slide'));
      this.indicators = Array.from(this.querySelectorAll('.hero-carousel__indicator'));

      this.totalSlides = parseInt(this.dataset.total) || this.indicators.length;
      this.currentIndex = 1; // Start at 1 because index 0 is the cloned last slide
      this.realIndex = 0;
      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = parseInt(this.dataset.speed) * 1000 || 5000;
      this.autoplayInterval = null;
      this.isDragging = false;
      this.startX = 0;
      this.isTransitioning = false;

      if (this.slides.length > 0) {
        this.init();
      }
    }

    init() {
      this.setPosition(false);
      this.bindEvents();
      this.updateIndicators();

      if (this.autoplay && this.totalSlides > 1) {
        this.startAutoplay();
      }
    }

    getOffset() {
      const slideWidth = this.slides[0].offsetWidth;
      const containerWidth = this.offsetWidth;
      const centerOffset = (containerWidth - slideWidth) / 2;
      return centerOffset - (this.currentIndex * slideWidth);
    }

    setPosition(animate = true) {
      const offset = this.getOffset();

      if (animate) {
        this.track.classList.add('is-animating');
      } else {
        this.track.classList.remove('is-animating');
      }

      this.track.style.transform = `translateX(${offset}px)`;
    }

    bindEvents() {
      // Indicator clicks
      this.indicators.forEach((indicator, index) => {
        indicator.addEventListener('click', () => {
          this.goToSlide(index);
        });
      });

      // Handle transition end for infinite loop
      this.track.addEventListener('transitionend', () => {
        this.isTransitioning = false;
        this.handleInfiniteLoop();
      });

      // Mouse drag events
      this.track.addEventListener('mousedown', (e) => this.startDrag(e));
      this.track.addEventListener('mousemove', (e) => this.drag(e));
      this.track.addEventListener('mouseup', (e) => this.endDrag(e));
      this.track.addEventListener('mouseleave', (e) => this.endDrag(e));

      // Touch events
      this.track.addEventListener('touchstart', (e) => this.startDrag(e), { passive: true });
      this.track.addEventListener('touchmove', (e) => this.drag(e), { passive: true });
      this.track.addEventListener('touchend', (e) => this.endDrag(e));

      // Prevent image dragging
      this.querySelectorAll('img').forEach(img => {
        img.addEventListener('dragstart', (e) => e.preventDefault());
      });

      // Pause on hover
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => {
        if (this.autoplay && !this.isDragging) this.startAutoplay();
      });

      // Handle resize
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          this.setPosition(false);
        }, 100);
      });
    }

    handleInfiniteLoop() {
      // If at cloned last slide (index 0), jump to real last slide
      if (this.currentIndex === 0) {
        this.currentIndex = this.totalSlides;
        this.setPosition(false);
      }
      // If at cloned first slide (index totalSlides + 1), jump to real first slide
      else if (this.currentIndex === this.totalSlides + 1) {
        this.currentIndex = 1;
        this.setPosition(false);
      }
    }

    startDrag(e) {
      if (this.isTransitioning) return;
      this.isDragging = true;
      this.startX = e.type === 'mousedown' ? e.pageX : e.touches[0].clientX;
      this.dragStartOffset = this.getOffset();
      this.track.classList.remove('is-animating');
      this.stopAutoplay();
    }

    drag(e) {
      if (!this.isDragging) return;
      const currentX = e.type === 'mousemove' ? e.pageX : e.touches[0].clientX;
      const diff = currentX - this.startX;
      this.track.style.transform = `translateX(${this.dragStartOffset + diff}px)`;
    }

    endDrag(e) {
      if (!this.isDragging) return;
      this.isDragging = false;

      const slideWidth = this.slides[0].offsetWidth;
      const endX = e.type === 'mouseup' ? e.pageX : (e.changedTouches ? e.changedTouches[0].clientX : this.startX);
      const movedBy = this.startX - endX;

      if (Math.abs(movedBy) > slideWidth / 5) {
        if (movedBy > 0) {
          this.next();
        } else {
          this.prev();
        }
      } else {
        this.setPosition(true);
      }

      if (this.autoplay) this.startAutoplay();
    }

    prev() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;
      this.currentIndex--;
      this.realIndex = (this.currentIndex - 1 + this.totalSlides) % this.totalSlides;
      this.setPosition(true);
      this.updateIndicators();
    }

    next() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;
      this.currentIndex++;
      this.realIndex = (this.currentIndex - 1) % this.totalSlides;
      this.setPosition(true);
      this.updateIndicators();
    }

    goToSlide(index) {
      if (this.isTransitioning) return;
      this.isTransitioning = true;
      this.currentIndex = index + 1; // +1 because of cloned slide at start
      this.realIndex = index;
      this.setPosition(true);
      this.updateIndicators();
    }

    updateIndicators() {
      this.indicators.forEach((indicator, index) => {
        indicator.classList.toggle('is-active', index === this.realIndex);
      });
    }

    startAutoplay() {
      if (this.autoplayInterval) return;
      this.autoplayInterval = setInterval(() => this.next(), this.speed);
    }

    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }
  }

  if (!customElements.get('hero-carousel')) {
    customElements.define('hero-carousel', HeroCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-carousel"] && !Shopify.designMode) return;
  try {
    
  class ProductsCarouselComponent extends HTMLElement {
    constructor() {
      super();
      this.list = this.querySelector('.products-carousel__list');
      this.prevBtn = this.querySelector('.products-carousel__btn--prev');
      this.nextBtn = this.querySelector('.products-carousel__btn--next');
      this.progressBar = this.querySelector('.products-carousel__progress-bar');
      this.items = this.querySelectorAll('.products-carousel__item');

      if (this.list) {
        this.init();
      }
    }

    init() {
      this.list.addEventListener('scroll', () => this.updateControls());
      this.prevBtn?.addEventListener('click', () => this.scroll(-1));
      this.nextBtn?.addEventListener('click', () => this.scroll(1));

      // Initialize on first load - use multiple methods to ensure it works
      this.updateControls();

      // Also run after a short delay to ensure DOM is fully rendered
      requestAnimationFrame(() => {
        this.updateControls();
      });

      // And after images might have loaded
      setTimeout(() => {
        this.updateControls();
      }, 100);

      const resizeObserver = new ResizeObserver(() => this.updateControls());
      resizeObserver.observe(this.list);
    }

    scroll(direction) {
      const itemWidth = this.items[0]?.offsetWidth || 200;
      const gap = 8;
      const scrollAmount = (itemWidth + gap) * 2;
      this.list.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
    }

    updateControls() {
      const { scrollLeft, scrollWidth, clientWidth } = this.list;
      const maxScroll = scrollWidth - clientWidth;

      if (this.prevBtn) {
        this.prevBtn.disabled = scrollLeft <= 1;
      }
      if (this.nextBtn) {
        this.nextBtn.disabled = scrollLeft >= maxScroll - 1;
      }

      // Update progress bar
      if (this.progressBar) {
        // Calculate progress as percentage (0 to 1)
        const progress = maxScroll > 0 ? scrollLeft / maxScroll : 0;

        // Calculate bar width based on visible portion (min 20%)
        const visibleRatio = scrollWidth > 0 ? clientWidth / scrollWidth : 1;
        const barWidthPercent = Math.max(20, visibleRatio * 100);

        // Calculate position - bar slides from 0% to (100% - barWidth)
        const maxLeftPercent = 100 - barWidthPercent;
        const leftPercent = progress * maxLeftPercent;

        this.progressBar.style.width = barWidthPercent + '%';
        this.progressBar.style.left = leftPercent + '%';
      }
    }
  }

  if (!customElements.get('products-carousel-component')) {
    customElements.define('products-carousel-component', ProductsCarouselComponent);
  }

  } catch(e) { console.error(e); }
})();
})();
